import React from 'react';

const ContactUs = () => {
    React.useEffect(() => {
      // To top
      const toTop = document.querySelector(".contact-floating");

      const onScroll = () => {
        const mainMenu = document.querySelector(".main-menu-area");
        const pos = window.scrollY;

        if (mainMenu) {
          if (pos >= 100) {
            mainMenu.classList.add("fixed-menu", "animate", "slideInDown");
          } else {
            mainMenu.classList.remove("fixed-menu", "animate", "slideInDown");
          }
        }

        // Scroll to top button
        if (pos >= 500) {
          toTop?.classList.add("fixed-totop");
        } else {
          toTop?.classList.remove("fixed-totop");
        }
      };

      // Scroll
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
          <a href="#kontakt-shared-desk" className="contact-floating">
            <div className="">Contact</div>
          </a>
    );

}

export default ContactUs;